.nsProduct {
  display: block;
}

.nsCard {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  color: inherit;
  text-decoration: none;
  background: #fff;
  border: 1px solid #e1e1e1;
  font-family: Oxygen, sans-serif;
  transition:
    box-shadow 180ms ease,
    transform 180ms ease,
    border-color 180ms ease;
}

.nsCard:hover {
  border-color: #d5d5d5;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);
  transform: translateY(-2px);
}

.nsCardOutOfStock::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 3;
  background: rgba(200, 200, 200, 0.45);
  pointer-events: none;
}

/* Media -------------------------------------------------------------- */

.nsMedia {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 2;
  overflow: hidden;
  background: #fff;
}

.nsImage,
.nsImageAlt {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nsImageAlt {
  opacity: 0;
  transition: opacity 180ms ease;
}

.nsCard:hover .nsImageAlt {
  opacity: 1;
}

/* Badges (drop / coming soon banner + DLT Exclusive) ----------------- */

.nsBadges {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

/* Orange "Dropping <date>" banner, flush to the top-left corner. */
.nsDropBadge {
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  background: #fa5700;
}

/* Green "Coming Soon" banner, same layout as the drop banner. */
.nsComingSoonBadge {
  background: #72ac72;
}

.nsExclusive {
  display: inline-flex;
  align-items: center;
}

.nsExclusiveIcon {
  height: 15px;
  max-width: 100%;
}

/* Body --------------------------------------------------------------- */

.nsBody {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.nsTitle {
  height: 53px;
  margin: 10px 0 6px;
  font-size: 13px;
  line-height: 1.35;
  font-weight: 400;
  color: #222;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
}

.nsPriceRow {
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin-top: auto;
  line-height: 24px;
}

.nsPrice {
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  color: #fa5700;
}

.nsOutOfStock {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% + 20px);
  margin: 0 -10px;
  line-height: 24px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fff;
  background: #000;
}

/* USA / shipping flags ----------------------------------------------- */

.nsFlags {
  display: flex;
  flex-wrap: nowrap;
  gap: 14px;
  margin-top: 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #2ca6d6;
}

.nsFlag {
  display: inline-flex;
  flex: 1 1 0;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: 5px;
  color: #2ca6d6;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.nsFlag:only-child {
  justify-content: flex-start;
}

.nsFlagUsa {
  text-decoration-color: #2ca6d6;
}

.nsFlagShipping {
  text-decoration-color: #fa5700;
}

.nsFlagIcon {
  height: 14px;
  max-width: 100%;
}

@media (max-width: 767px) {
  .nsFlags {
    flex-direction: column;
  }

  .nsFlag {
    justify-content: flex-start;
  }
}
